<a [routerLink]="['../recommendation']" queryParamsHandling="merge"><button class="iconf-btn-filled minh40 minw200">get system summary</button> </a>
